import React, { useCallback, useEffect, useImperativeHandle, useState } from 'react';
import { Platform, Share, } from 'react-native';
import { Button, withTheme } from '@rneui/themed';
import Toast from 'react-native-toast-message';
import { FAIcon } from '../elements';
const isWebPlatform = Platform.OS === 'web';
const getShareContentForPlatform = (link) => {
    if (Platform.OS === 'android') {
        return {
            message: link,
        };
    }
    else {
        return {
            url: link,
        };
    }
};
export const UnthemedShareButton = React.forwardRef(({ link, size, iconStyle, buttonStyle, }, ref) => {
    const [isShareAvailable, setIsShareAvailable] = useState(true);
    useEffect(() => {
        if (isWebPlatform && window?.navigator?.share === undefined) {
            setIsShareAvailable(false);
        }
    }, []);
    const onShare = useCallback(async () => {
        try {
            const content = getShareContentForPlatform(link);
            await Share.share(content);
        }
        catch (err) {
            let msg = 'An error occurred when attempting to share.';
            if (isWebPlatform) {
                msg = err.message;
            }
            else {
                Toast.show({
                    type: 'error',
                    text1: 'Uh oh!',
                    text2: 'An error occurred when attempting to share.',
                });
            }
        }
    }, [link]);
    const onCopy = useCallback(async () => {
        if (isWebPlatform) {
            await window.navigator.clipboard.writeText(link);
            Toast.show({
                type: 'success',
                text1: 'Link copied!',
            });
        }
        else {
            Toast.show({
                type: 'error',
                text1: 'Uh oh!',
                text2: 'An error occurred when attempting to share.',
            });
        }
    }, [link]);
    const onShareWrapped = useCallback(async () => {
        if (isShareAvailable) {
            await onShare();
        }
        else {
            await onCopy();
        }
    }, [isShareAvailable]);
    useImperativeHandle(ref, () => {
        return { toggle: onShareWrapped };
    }, [onShareWrapped]);
    return (React.createElement(Button, { type: "clear", onPress: onShareWrapped, style: buttonStyle },
        React.createElement(FAIcon, { name: "share", size: size, style: iconStyle })));
});
export const ShareButton = withTheme(UnthemedShareButton, 'ShareButton');
//# sourceMappingURL=ShareButton.js.map